import { formatISODate } from '../shared/utils';

export function wellnessOptionsWithStatusForSelectedPet(pet) {
  const wellnessPlans = pet.wellness_plans || [];
  return wellnessPlans.map(wellness => {
    const formattedEffectiveDate = formatISODate(wellness?.coverage_start_date, {
      isGenerated: true,
    });
    return {
      id: wellness?.id,
      name: `${formattedEffectiveDate} - ${wellness?.status}`,
      formattedEffectiveDate,
    };
  });
}
